export const CHANGES_TAB = 'diffs';
export const DISCUSSION_TAB = 'notes';
export const SHOW_TAB = 'show';

export const REVIEW_BAR_VISIBLE_CLASS_NAME = 'review-bar-visible';
